/**
 * @generated SignedSource<<ee5499c00a861407898b350b94a66324>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionApproverStatus = "APPROVED" | "DECLINED" | "PENDING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type approvalStatus_softwareReleasesApprovers$data = {
  readonly id: string;
  readonly status: JiraVersionApproverStatus;
  readonly user: {
    readonly accountId: string;
  };
  readonly " $fragmentType": "approvalStatus_softwareReleasesApprovers";
};
export type approvalStatus_softwareReleasesApprovers$key = {
  readonly " $data"?: approvalStatus_softwareReleasesApprovers$data;
  readonly " $fragmentSpreads": FragmentRefs<"approvalStatus_softwareReleasesApprovers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "approvalStatus_softwareReleasesApprovers",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "status"
      },
      "action": "THROW",
      "path": "status"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "accountId"
            },
            "action": "THROW",
            "path": "user.accountId"
          }
        ]
      },
      "action": "THROW",
      "path": "user"
    }
  ],
  "type": "JiraVersionApprover"
};

(node as any).hash = "a9facaa120985a7b998fdeec16b9f3e0";

export default node;
